import { TrackOptions } from "./global";
import { getUserTraits } from "./segmentio";

const wait = (delay: number) => new Promise((resolve) => setTimeout(resolve, delay));

export async function track(data: TrackOptions): Promise<void> {
  const defaultProperties = {
    page: null,
    location: null,
    section: null,
    subsection: null,
    eventType: null,
    elementType: null,
  };
  try {
    if (!data) {
      console.warn("Data must be passed to the track event");
      return;
    }
    if (!data.event) {
      console.warn("Event name is required");
      return;
    }
    const userTraits = getUserTraits();
    const optionalProperties = data.properties ? data.properties : {};
    const combinedProperties = {
      ...defaultProperties,
      ...userTraits,
      ...optionalProperties,
    };

    window.analytics?.track(data.event, combinedProperties);
    window.DD_RUM?.addAction(data.event, data.properties);
  } catch (error) {
    console.log("Failed to track event", error);
  } finally {
    // Generally used to give the browser time to make outbound requests
    // (send the events) before a redirect. We want to run this even if
    // tracking fails because tracking is non critical behavior.
    await wait(300);
  }
}
